import { API_ROUTES } from "../../utils/constants";
import { AxiosBase } from "./index";

export default class OrganisationService extends AxiosBase {
  addOrganization = async (body, navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.ORGANIZATION.ORG}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  getAllOrganization = async ({
    page,
    limit,
    navigate,
    searchQuery,
    sortKey,
    sortDirection,
    getAll = false,
  }) => {
    try {
      const baseUrl = API_ROUTES.ORGANIZATION.ORG;
      const url = getAll
        ? baseUrl
        : `${baseUrl}?page=${page}&limit=${limit}&searchQuery=${searchQuery}&sortKey=${sortKey}&sortDirection=${sortDirection}`;
      const response = await this.requests.get(url);
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  removeOrganization = async (id, navigate) => {
    try {
      const response = await this.requests.delete(
        `${API_ROUTES.ORGANIZATION.ORG}/${id}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  editOrganization = async (id, body, navigate) => {
    try {
      const response = await this.requests.put(
        `${API_ROUTES.ORGANIZATION.ORG}/${id}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  activateOrganization = async (id, body, navigate) => {
    try {
      const response = await this.requests.put(
        `${API_ROUTES.ORGANIZATION.ORG}/${id}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
}
